import { isEmpty } from '@sgme/fp';
import { SgwtAccountCenter } from '@sgwt/sgwt-widgets-react';
import { getImpersonatedUser } from 'api/connect';
import { useIsNotInProduction } from 'contexts/environment/useIsProduction';
import { langs } from 'locales';

import type { AccountCenterProps } from './AccountCenter.connect';
import { setFakeSso, useTopLabel } from './utils';

const additionalLanguages = { it: { id: 'Italiano' } };

function handleStopNavigateAs() {
  setFakeSso(null);
}

export function AccountCenter({ currentLanguage, onLanguageChanged, onThemeChanged }: AccountCenterProps) {
  const isNonProduction = useIsNotInProduction();
  const navigateAsUsersList = window.sgmeConfiguration.navigateAs?.map(({ name, mail, company }) => ({
    name,
    mail,
    company,
  }));
  const producerCode = window.sgmeConfiguration.incidentNotificationProducerCode;
  const hasNavigateAs = isNonProduction && !isEmpty(navigateAsUsersList);
  const currentUser = getImpersonatedUser();
  const topLabel = useTopLabel();

  return (
    <SgwtAccountCenter
      language={currentLanguage}
      producerCode={producerCode}
      environment={topLabel}
      navigateAs={hasNavigateAs}
      authentication="sg-connect"
      mode="sg-markets"
      navigateAsUser={currentUser ?? undefined}
      navigateAsList={hasNavigateAs ? navigateAsUsersList : undefined}
      onNavigateAsSelectUser={evt => {
        const userName = evt.mail;
        if (userName !== undefined) {
          setFakeSso(userName);
        }
      }}
      onLanguageChanged={onLanguageChanged}
      onStopNavigationAs={handleStopNavigateAs}
      i18n={additionalLanguages}
      themeSwitcher
      onThemeChanged={onThemeChanged}
      availableLanguages={langs}
    />
  );
}
